import React from "react";
import type { Illustration } from "../util";
import { illustrationProps } from "../util";

export const ReceiptsCompanies: Illustration = (props) => (
  <svg viewBox="0 0 320 144" {...illustrationProps(props, { width: 320 })}>
    <path
      d="M10.32 80.045a55.492 55.492 0 0 1-1.991-1.97 1.15 1.15 0 0 1-.02-1.59c.397-.44 1.183-.445 1.59-.019a55.079 55.079 0 0 0 1.967 1.948 57.23 57.23 0 0 1 2.06-2.085 1.15 1.15 0 0 1 1.59-.02c.44.397.444 1.183.018 1.59a56.74 56.74 0 0 0-2.037 2.061c.71.671 1.426 1.337 2.17 1.972.476.407.404 1.162.02 1.59-.423.473-1.143.397-1.59.018a54.375 54.375 0 0 1-2.146-1.948c-.64.68-1.275 1.365-1.882 2.076-.408.475-1.163.403-1.59.019-.474-.423-.398-1.143-.019-1.59a52.898 52.898 0 0 1 1.86-2.052Z"
      fill="#FF9494"
    />
    <path
      d="M300.513 65.182c0-1.868.813-3.526 2.628-4.345 1.814-.82 3.856-.322 5.167 1.055 1.203 1.271 1.491 3.369.826 4.948-.772 1.822-2.721 2.91-4.717 2.674-2.21-.262-3.863-2.169-3.897-4.332-.02-1.58-2.54-1.586-2.52 0 .04 2.989 2.036 5.65 4.979 6.528 2.943.879 6.068-.301 7.795-2.707 1.599-2.228 1.626-5.545.127-7.826-1.632-2.484-4.757-3.703-7.693-2.962-1.613.406-2.997 1.396-3.958 2.707-.961 1.31-1.25 2.733-1.25 4.254 0 1.52 2.52 1.586 2.52 0l-.007.006ZM88.684 27.311c-.17 6.817-.333 13.628-.504 20.445l-.074 2.937c-.04 1.742 2.599 1.745 2.641-.005.171-6.816.333-13.627.504-20.444l.075-2.937c.04-1.742-2.6-1.745-2.642.005Z"
      fill="#FFB3B3"
    />
    <path
      d="M79.261 40.133c6.569.04 13.13.077 19.698.116.918.004 1.836.008 2.752.02 1.698.007 1.73-2.702.028-2.717l-19.698-.117c-.918-.004-1.836-.008-2.752-.02-1.698-.006-1.73 2.702-.028 2.718Z"
      fill="#FFB3B3"
    />
    <path
      d="M96.931 29.31 82.524 43.579c-.687.686-1.379 1.363-2.066 2.049-1.231 1.224.592 3.163 1.823 1.939l14.407-14.27c.687-.685 1.379-1.362 2.066-2.048 1.231-1.225-.592-3.164-1.823-1.94Z"
      fill="#FFB3B3"
    />
    <path
      d="M81.506 31.63c4.564 4.801 9.118 9.607 13.681 14.408l1.91 2.016c1.179 1.245 3.086-.653 1.909-1.898-4.555-4.806-9.118-9.606-13.673-14.412l-1.91-2.017c-1.178-1.244-3.086.654-1.908 1.899l-.009.005Z"
      fill="#FFB3B3"
    />
    <path
      d="M285.955 41.123a2.605 2.605 0 0 0-1.229-1.753c-.633-.366-1.508-.418-2.234-.337-.471.051-.881.16-1.259.429a1.826 1.826 0 0 0-.627.807c-.348.126-.559.418-.596.79-.068.665.217 1.335.689 1.839.18.297.422.543.769.698.373.166.764.27 1.167.327.856.12 1.874.171 2.569-.396.273-.223.41-.51.453-.818.05-.07.093-.138.131-.207.223-.446.254-.899.167-1.38Zm-3.283.189s.013-.012 0 0Z"
      fill="#FF9494"
    />
    <path
      d="M126.774 69H60.226C57.34 69 55 71.37 55 74.293v52.414c0 2.923 2.34 5.293 5.226 5.293H132V74.293c0-2.923-2.34-5.293-5.226-5.293Z"
      fill="#FFB800"
    />
    <path
      d="M117 132V69H44.294A5.294 5.294 0 0 0 39 74.293v52.414A5.294 5.294 0 0 0 44.294 132H117Z"
      fill="#FFD600"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58 93h30v39H58V93Zm38.61 0h11.779c1.994 0 3.611 1.542 3.611 3.444v24.112c0 1.902-1.617 3.444-3.611 3.444H96.611c-1.994 0-3.611-1.542-3.611-3.444V96.444C93 94.542 94.617 93 96.61 93Z"
      fill="#FFED89"
    />
    <path
      d="M37.647 84c20.193-.066 38.568-.547 58.77-.471 6.165.019 17.775.094 23.94.216 2.191.048 2.191-3.488 0-3.535-20.585-.424-46.624-.113-67.218.123-5.773.066-9.719.113-15.492.132-2.191 0-2.2 3.544 0 3.535Z"
      fill="#EE7903"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.5 102.402A6.002 6.002 0 0 1 22 100a6 6 0 0 1 11.5-2.402 6.001 6.001 0 0 1 11 0 6.001 6.001 0 0 1 11 0 6.001 6.001 0 0 1 11 0A6.001 6.001 0 0 1 78 100a6 6 0 0 1-11.5 2.402 6.002 6.002 0 0 1-11 0 6.002 6.002 0 0 1-11 0 6.002 6.002 0 0 1-11 0Z"
      fill="#EE7903"
    />
    <path d="M22 97h56v3H22v-3Z" fill="#EE7903" />
    <path d="M22 93a3 3 0 0 1 3-3h60a3 3 0 0 1 3 3v5H22v-5Z" fill="#FEA628" />
    <path
      d="M223.722 33h-94.444c-4.02 0-7.278 3.246-7.278 7.251v84.498c0 4.005 3.258 7.251 7.278 7.251h94.444c4.02 0 7.278-3.246 7.278-7.251V40.251c0-4.005-3.258-7.251-7.278-7.251Z"
      fill="#7C7FFF"
    />
    <path
      d="M259 40.251c0-4.005-3.258-7.251-7.278-7.251H150v99h101.722c4.02 0 7.278-3.246 7.278-7.251V40.251Z"
      fill="#97A1FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M149 91h32.71c2.367 0 4.29 1.79 4.29 3.994v20.012c0 2.204-1.923 3.994-4.29 3.994H149V91Zm49.292 0h38.425c1.818 0 3.283 1.42 3.283 3.16V132h-45V94.16c0-1.75 1.475-3.16 3.283-3.16h.009Zm52.332 28H259V91h-8.376c-1.996 0-3.624 1.48-3.624 3.315v21.37c0 1.825 1.619 3.315 3.624 3.315Z"
      fill="#BEC4FF"
    />
    <path
      d="M150 119h-5.651c-2.4 0-4.349-1.79-4.349-3.994V94.994c0-2.204 1.949-3.994 4.349-3.994H150v28Z"
      fill="#97A1FF"
    />
    <path
      d="M218.216 94.667c-.126 11.935-.2 15.553-.208 27.498 0 2.045-.037 4.109.045 6.163.089 2.22 2.873 2.239 2.784 0-.201-4.895-.038-6.135-.023-11.03.03-7.031.075-9.428.134-16.46.015-2.054.03-4.108.052-6.162.022-2.23-2.761-2.24-2.784 0v-.01Z"
      fill="#7C7FFF"
    />
    <path
      d="M149.647 52.838c4.01.313 8.111.076 12.12.076 8.659 0 17.326-.038 25.985-.067 10.284-.038 20.559-.085 30.843-.123 9.024-.038 18.038-.067 27.062-.076 4.749 0 9.499 0 14.248.057.146 0 .301 0 .448.019 2.201.17 2.192-3.39 0-3.562-4.01-.313-8.111-.076-12.12-.076-8.659 0-17.326.038-25.985.067-10.284.038-20.559.085-30.843.123-9.024.038-18.038.067-27.062.076-4.749 0-9.499 0-14.248-.057-.146 0-.301 0-.448-.019-2.201-.17-2.192 3.39 0 3.562Z"
      fill="#4D5BE0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M173 58h-28v9h28v5a8 8 0 0 0 8 8h82a8 8 0 0 0 8-8v-6a8 8 0 0 0-8-8h-90Z"
      fill="#7C7FFF"
    />
    <path d="M170 67h6a4 4 0 0 1 4 4v9h-2a8 8 0 0 1-8-8v-5Z" fill="#4D5BE0" />
    <rect x="169" y="16" width="70" height="28" rx="4" fill="#4D5BE0" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M183.29 30.737c-1.35 1.27-2.04 2.626-2.04 4.013a1.5 1.5 0 0 1-3 0c0-2.47 1.246-4.564 2.986-6.2 1.735-1.63 4.054-2.9 6.493-3.782 2.448-.884 5.098-1.405 7.555-1.483 2.427-.076 4.82.276 6.642 1.294 1.226.685 1.952 1.732 2.361 2.832l.267-.047c3.217-.557 6.75-.606 9.512.263 1.19.375 2.314.945 3.197 1.788a36.66 36.66 0 0 1 4.596-.756c1.731-.17 3.503-.21 5.113-.033 1.583.173 3.15.57 4.36 1.376a1.5 1.5 0 1 1-1.664 2.496c-.634-.423-1.652-.74-3.023-.89-1.345-.147-2.898-.12-4.493.037a33.479 33.479 0 0 0-3.306.497c.148.61.2 1.267.15 1.965-.098 1.377-1.039 2.733-2.066 3.615-1.03.884-2.642 1.706-4.342 1.22-1.097-.313-2.015-.868-2.57-1.73-.569-.885-.612-1.866-.393-2.714.412-1.594 1.784-2.983 3.241-3.663.182-.085.375-.17.579-.253a8.344 8.344 0 0 0-.28-.093c-2.129-.67-5.128-.684-8.099-.17l-.294.053c.001.732-.068 1.435-.165 2.054-.283 1.81-1.752 3.539-3.323 4.557-1.56 1.01-3.906 1.733-5.898.364l-.107-.074-.093-.09c-1.049-1.03-1.58-2.31-1.256-3.69.293-1.246 1.213-2.229 2.211-2.967 1.333-.986 3.17-1.805 5.187-2.408a2.138 2.138 0 0 0-.865-.92c-1.156-.646-2.932-.982-5.085-.914-2.122.067-4.46.523-6.63 1.306-2.177.786-4.103 1.873-5.458 3.147Zm18.451.394c-1.574.507-2.91 1.137-3.816 1.807-.762.564-1.019 1.006-1.075 1.242-.022.095-.066.324.334.755.512.279 1.375.238 2.468-.47 1.155-.748 1.886-1.833 1.991-2.502.042-.272.076-.551.098-.832Zm14.196 1.746c-.705.22-1.318.45-1.803.677-.836.39-1.465 1.154-1.604 1.695-.057.22-.013.302.01.339.038.058.219.283.872.47.292.083.871-.018 1.564-.612.695-.598 1.008-1.276 1.028-1.553a3.41 3.41 0 0 0-.067-1.016Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M277.229 128.833c0-1.696 1.257-2.969 3.209-2.969 2.407 0 2.808 2.121 2.808 3.393 0 1.631-1.605 2.969-3.61 2.545-1.605-.339-2.407-1.487-2.407-2.969Zm11.44 0c0-1.696 1.257-2.969 3.209-2.969 2.407 0 2.808 2.121 2.808 3.393 0 1.631-1.604 2.969-3.61 2.545-1.604-.339-2.407-1.487-2.407-2.969Z"
      fill="#76C82E"
    />
    <path
      d="M272 106.61h28.955a1 1 0 0 1 .912 1.41l-4.238 9.443a1.999 1.999 0 0 1-1.824 1.181h-19.512L272 106.61Z"
      fill="#76C82E"
    />
    <path
      d="M267 103h2.453a3 3 0 0 1 2.93 2.353l3.823 17.294a2.998 2.998 0 0 0 2.929 2.353H295"
      stroke="#22AE00"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);
